import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Col from '@loggi/ui/components/col';
import Display from '@loggi/ui/components/display';
import Icon from '@loggi/ui/components/icon';
import icons from '@loggi/ui/components/utils/icons';
import screen from '@loggi/ui/components/utils/screens';
import { privatePackageTrackerModel } from 'app.models';
import { locationModel } from 'app/app.models';
import getStatusPath from 'app/app.utils';
import emoji from 'images/sad.png';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserFeedbackAlert from 'shared/alert/user-feedback-alert/user-feedback-alert.component';
import Card from 'shared/card/card.component';
import FacilitateDelivery from 'shared/facilitate-delivery/facilitate-delivery.component';
import MainView from 'shared/main-view/main-view.component';
import confirmOriginalAddressMutation from 'shared/relay/mutations/confirm-original-address.mutation';
import getStatus from 'shared/status/get-status.service';
import * as appActions from 'tracker.actions';
import {
  CAN_CLASSIFY_DESTINATION,
  CAN_EDIT_FULL_ADDRESS,
  FEEDBACK_ALERT_ERROR_TITLE,
  RETRY_BUTTON_VALUE
} from 'tracker.constants';
import {
  ADDITIONAL_RECEIVERS,
  CLASSIFICATION,
  EDIT_ADDRESS,
  INSTRUCTIONS,
  SUCCESS
} from 'tracker.routes';
import MainPackageInfoCard from './main-package-info-card/main-package-info-card.component';
import {
  AppBeyondMobile,
  AppBeyond
} from '../../public-tracker/components/app-beyond/app-beyond.component';
import {
  CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION,
  POLLING_TIME,
  SHOULD_NOT_CONFIRM_ORIGINAL_ADDRESS,
  SHOULD_NOT_RENDER_CLASSIFICATION_CARD
} from './package.constants';
import queryStatusData from './package.service';
import styles from './package.styles.scss';
import Polling from './polling/polling.service';
import { LOGGIAPP_ORIGIN_IDENTIFYER } from '../../tracker.constants';

export class StatusContainer extends Component {
  constructor(props) {
    super(props);

    this.polling = null;

    const permissions = get(props, 'privatePackageTracker.permissions', null);

    const isAddressCorrect = get(
      props,
      'privatePackageTracker.destinationInfo.confirmedByRecipient',
      null
    );

    const privatePackageTracker = get(props, 'privatePackageTracker', null);

    const redispatchInfo = get(privatePackageTracker, 'redispatchInfo', null);
    const trackingCode = get(redispatchInfo, 'trackingCode', null);
    const maxPickupTime = get(redispatchInfo, 'maxPickupTime', null);

    const packageStatus = getStatus(privatePackageTracker);

    const canEdit =
      !!permissions && permissions.includes(CAN_EDIT_FULL_ADDRESS);

    const isRedispatch = trackingCode !== null;

    const canShowRecipientPickupInfo = isRedispatch && maxPickupTime !== null;

    const canConfirmOriginalAddress =
      !SHOULD_NOT_CONFIRM_ORIGINAL_ADDRESS.includes(packageStatus) &&
      !isRedispatch;

    const canClassifyDestination =
      !!permissions &&
      permissions.includes(CAN_CLASSIFY_DESTINATION) &&
      !SHOULD_NOT_RENDER_CLASSIFICATION_CARD.includes(packageStatus) &&
      !isRedispatch;

    const relativeEta = get(props, 'privatePackageTracker.relativeEta', null);

    const currentStatus = get(
      props,
      'privatePackageTracker.currentStatus',
      null
    );

    const shipperStatus = get(
      props,
      'privatePackageTracker.shipperStatus',
      null
    );

    const currentDriverPosition = get(
      props,
      'privatePackageTracker.currentDriverPosition',
      null
    );

    const driverInfo = get(props, 'privatePackageTracker.driverInfo', null);

    this.state = {
      isAddressCorrect,
      canClassifyDestination,
      canEdit,
      canConfirmOriginalAddress,
      canShowRecipientPickupInfo,
      userFeedbackAlert: false,
      userFeedbackAlertProps: {
        illustration: emoji,
        title: FEEDBACK_ALERT_ERROR_TITLE,
        description: CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION,
        buttonsProps: [
          { value: RETRY_BUTTON_VALUE, onClick: this._onClickRetry }
        ]
      },
      relativeEta,
      currentDriverPosition,
      hasPolling: false,
      driverInfo,
      currentStatus,
      shipperStatus
    };
    this._onClickToChangeAddress = this._onClickToChangeAddress.bind(this);
    this._syncQueryStatusData = this._syncQueryStatusData.bind(this);
  }

  componentDidMount() {
    this._onCreatePolling();

    const { relativeEta, currentDriverPosition } = this.state;

    const shouldCallPolling = this._isGoingToRecipient(
      relativeEta,
      currentDriverPosition
    );

    if (shouldCallPolling) {
      this.polling.start();
      this.setState({ hasPolling: true });
    }
  }

  componentWillUnmount() {
    const { hasPolling } = this.state;
    if (hasPolling) {
      this.polling.stop();
    }
  }

  _onConfirmOriginalAddress = () => {
    const { privatePackageTracker, actions } = this.props;
    const {
      packageInfo: { packageId }
    } = privatePackageTracker;

    this.setState({ isAddressCorrect: true }, () => {
      actions.savePrivatePackageTracker({
        privatePackageTracker,
        pathname: getStatusPath(packageId)
      });

      const callbacks = {
        onSuccess: response =>
          this._onSuccessOriginalAddressMutation(
            response.packageTrackerAddressConfirmation
          ),

        onFailure: () => this._onFailureOriginalAddressMutation()
      };

      this._onConfirmOriginalAddressMutation(callbacks);
    });
  };

  _onClickRetry = () => {
    const callbacks = {
      onSuccess: response =>
        this._onSuccessOriginalAddressMutation(
          response.packageTrackerAddressConfirmation
        ),
      onFailure: () => this._onFailureOriginalAddressMutation()
    };

    this.setState({ userFeedbackAlert: false }, () => {
      return this._onConfirmOriginalAddressMutation(callbacks);
    });
  };

  _renderHeader = () => {
    return (
      <Col className="header-icon">
        <Icon type={icons.type.LOGGI} color="blue-500" />
      </Col>
    );
  };

  _isGoingToRecipient = (relativeEta, currentDriverPosition) => {
    return Boolean(relativeEta && relativeEta > 0 && currentDriverPosition);
  };

  _onClickToDenyOriginalAddress = () => {
    return this.setState({ isAddressCorrect: false }, () => {
      const { canEdit } = this.state;

      const onSuccess = canEdit ? this._onClickToChangeAddress() : null;

      const callbacks = {
        onSuccess: () => onSuccess,
        onFailure: () => this._onFailureOriginalAddressMutation()
      };
      this._onConfirmOriginalAddressMutation(callbacks);
    });
  };

  _goToNextScreen = nextPathname => {
    const { privatePackageTracker, actions, history } = this.props;

    let {
      location: { pathname }
    } = this.props;

    // Prepare pathname to next path
    if (pathname.charAt(pathname.length - 1) === '/') {
      pathname = pathname.slice(0, -1);
    }

    const {
      packageInfo: { packageId }
    } = privatePackageTracker;

    actions.savePrivatePackageTracker({
      privatePackageTracker,
      pathname: getStatusPath(packageId)
    });

    const queryString = history.location.search;
    if (queryString) {
      return history.push(`${pathname}/${nextPathname}${queryString}`);
    }

    return history.push(`${pathname}/${nextPathname}`);
  };

  _onConfirmOriginalAddressMutation = callbacks => {
    const {
      privatePackageTracker: {
        packageInfo: { packageId }
      }
    } = this.props;

    const { isAddressCorrect } = this.state;

    return confirmOriginalAddressMutation(
      packageId,
      isAddressCorrect,
      callbacks
    );
  };

  _syncQueryStatusData(data) {
    const {
      privatePackageTracker: {
        relativeEta,
        currentDriverPosition,
        driverInfo,
        currentStatus
      }
    } = data;

    const shouldKeepPolling = this._isGoingToRecipient(
      relativeEta,
      currentDriverPosition
    );

    this.setState({
      relativeEta,
      currentDriverPosition,
      hasPolling: shouldKeepPolling,
      driverInfo,
      currentStatus
    });

    if (!shouldKeepPolling) this.polling.stop();
  }

  _onCreatePolling() {
    const packageId = get(
      this.props,
      'privatePackageTracker.packageInfo.packageId',
      null
    );

    this.polling = new Polling(packageId, POLLING_TIME, {
      onSuccess: data => this._syncQueryStatusData(data),
      onQuery: queryStatusData
    });
  }

  _onSuccessOriginalAddressMutation({ success }) {
    if (!success) {
      return this._onFailureOriginalAddressMutation();
    }

    this.setState({
      isAddressCorrect: true
    });

    return this._goToNextScreen(SUCCESS);
  }

  _onFailureOriginalAddressMutation() {
    return this.setState({
      userFeedbackAlert: true,
      userFeedbackAlertProps: {
        illustration: emoji,
        title: FEEDBACK_ALERT_ERROR_TITLE,
        description: CONFIRM_ORIGINAL_ADDRESS_ERROR_DESCRIPTION,
        buttonsProps: [
          { value: RETRY_BUTTON_VALUE, onClick: this._onClickRetry }
        ]
      }
    });
  }

  _onClickToChangeAddress() {
    const { actions } = this.props;
    actions.saveScreenFlow({
      hasFinishedScreenFlow: false
    });

    return this._goToNextScreen(EDIT_ADDRESS);
  }

  _getOrigin() {
    const { location } = this.props;
    const queryParams = new URLSearchParams(location.search);
    return queryParams.get('origin');
  }

  _isLoggiAppRequest() {
    return this._getOrigin() === LOGGIAPP_ORIGIN_IDENTIFYER;
  }

  render() {
    const {
      canEdit,
      canConfirmOriginalAddress,
      canClassifyDestination,
      canShowRecipientPickupInfo,
      userFeedbackAlert,
      userFeedbackAlertProps,
      relativeEta,
      driverInfo,
      currentStatus,
      shipperStatus,
      isAddressCorrect
    } = this.state;
    const { privatePackageTracker } = this.props;
    const {
      destinationInfo: {
        classificationType,
        instructions,
        additionalReceivers
      },
      packageInfo: { companyName },
      eta,
      recipientInfo: { firstName },
      redispatchInfo,
      receivedBy
    } = privatePackageTracker;
    const { getScreen, sizes } = screen;
    const isSmallScreen = getScreen() < sizes.md;
    const statusInfo = {
      firstName,
      companyName,
      currentStatus,
      shipperStatus,
      relativeEta,
      eta,
      redispatchInfo
    };

    return (
      <Col className="beyond-iframe-view" size={12}>
        <Col size={{ md: 6, lg: 6, xl: 7, xxl: 7 }}>
          <MainView
            className={`tracker-content tracker-content-beyond ${
              styles.packageContainer
            }`}
          >
            <Display when={isSmallScreen && !this._isLoggiAppRequest()}>
              {this._renderHeader()}
            </Display>
            <Col className="menu-view">
              <MainPackageInfoCard
                privatePackageTracker={privatePackageTracker}
                driverInfo={driverInfo}
                statusInfo={statusInfo}
                isAddressCorrect={isAddressCorrect}
                canEditAddress={canEdit}
                canConfirmOriginalAddress={canConfirmOriginalAddress}
                canShowRecipientPickupInfo={canShowRecipientPickupInfo}
                onClickToChangeAddress={this._onClickToChangeAddress}
                onClickToDenyOriginalAddress={
                  this._onClickToDenyOriginalAddress
                }
                onClickToConfirmOriginalAddress={this._onConfirmOriginalAddress}
                receivedBy={receivedBy}
                isOriginLoggiApp={this._isLoggiAppRequest()}
              />
              {canClassifyDestination && (
                <Card>
                  <FacilitateDelivery
                    destinationType={classificationType}
                    onClickDestinationType={() =>
                      this._goToNextScreen(CLASSIFICATION)
                    }
                    destinationDescription={instructions}
                    onClickDestinationDescription={() =>
                      this._goToNextScreen(INSTRUCTIONS)
                    }
                    additionalReceivers={additionalReceivers}
                    onClickAdditionalReceivers={() =>
                      this._goToNextScreen(ADDITIONAL_RECEIVERS)
                    }
                  />
                </Card>
              )}
            </Col>
            {userFeedbackAlert && (
              <UserFeedbackAlert
                illustration={userFeedbackAlertProps.illustration}
                title={userFeedbackAlertProps.title}
                description={userFeedbackAlertProps.description}
                buttonsProps={userFeedbackAlertProps.buttonsProps}
              />
            )}
          </MainView>
          <Col className="menu-view-beyond">
            {!this._isLoggiAppRequest() && <AppBeyondMobile />}
          </Col>
        </Col>
        <AppBeyond />
      </Col>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(appActions, dispatch)
  };
}

StatusContainer.displayName = 'StatusContainer';

StatusContainer.propTypes = {
  privatePackageTracker: PropTypes.shape(privatePackageTrackerModel).isRequired,
  history: PropTypes.func.isRequired,
  actions: PropTypes.shape({
    savePrivatePackageTracker: PropTypes.func.isRequired,
    saveScreenFlow: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape(locationModel).isRequired
};

export default connect(
  null,
  mapDispatchToProps
)(StatusContainer);
